"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isValidPersonId = exports.formatIdentification = void 0;
var identificationTypes_1 = require("../../constants/identificationTypes");
/**
 * Return true if the provided string is a number
 */
function isNumber(value) {
    var regex = /^\d+$/;
    var result = regex.exec(value);
    return result !== null;
}
/**
 * Will add a leading "0" for identifications that require it, unless the
 * specified idType marks it as a passport
 */
function formatIdentification(value, idType) {
    // Don't do anything if provided with a passport
    if (idType === identificationTypes_1.PASSPORT) {
        return value;
    }
    var completeValue = value;
    var indexOf = value.indexOf('-');
    var valueSubs = value.substring(0, indexOf);
    if (valueSubs.length === 1 && isNumber(valueSubs)) {
        completeValue = "0" + completeValue;
    }
    return completeValue;
}
exports.formatIdentification = formatIdentification;
/**
 * Will return true if the provided id follows the defined pattern for valid ids
 */
function isValidPersonId(id) {
    return /^(\d{1,2}|[a-zA-Z]{1,2})(-(\d)+){2}$/.exec(id) !== null;
}
exports.isValidPersonId = isValidPersonId;
//# sourceMappingURL=identifications.js.map